<template>
  <div class="collapse-container">
    <div @click="setActive()" :class="{ active: isActive() }" class="collapsible">
      <div class="collapse__stage">
        <slot name="icon">{{ index }}</slot>
      </div>
      <div class="collapse-header">
        <div class="collapse__title">
          <slot name="title"></slot>
        </div>
        <div class="collapse__subtitle">
          <slot name="subtitle"></slot>
        </div>
      </div>
      <svg class="right-arrow">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-right2" />
      </svg>
    </div>
    <div :class="{ active: isActive() }" class="collapse-content-container">
      <slot name="default"></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';

const props = defineProps({
  index: {
    type: Number,
  },
  modelValue: {
    type: Number,
  },
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
}>();
const value = useVModel(props, 'modelValue', emit);

function isActive() {
  return props.index === value.value;
}

function setActive() {
  value.value = props.index;
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.collapse-container {
  background-color: #fff;
  border-radius: 6px;

  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.1);

  &:hover {
    box-shadow: 0 3px 16px 0 rgba(0, 0, 0, 0.2);
  }

  &:not(:last-child) {
    margin-bottom: 1.5em;
  }

  .collapse__stage {
    flex: 0 0 auto;
    font-weight: 700;
    font-size: 1.5rem;
    color: $color-netcall-salmon;
    width: 4rem;
    text-align: center;
  }

  .collapse__title {
    font-weight: 500;
    font-size: 1.2em;
  }

  .collapse__subtitle {
    opacity: 0.7;
    line-height: 1.35;
  }

  /* Style the button that is used to open and close the collapsible content */
  .collapsible {
    cursor: pointer;
    background-color: #fff;
    width: 100%;
    border: none;
    text-align: left;
    outline: none;
    border-radius: 6px;
    padding: 1.75rem 0.25rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .collapse-header {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      flex: 1 1 auto;
    }
    .right-arrow {
      height: 1em;
      width: 4rem;
      stroke: $primary;
      transition: transform 200ms;
    }

    &.active {
      .right-arrow {
        transform: rotate(90deg);
      }
    }
  }

  .collapse-content-container {
    overflow: hidden;
    transition: padding max-height 300ms ease-out;
    max-height: 0;
    padding: 0 4.25rem;

    &.active {
      padding: 0rem 4.25rem 2rem 4.25rem;
      transition: padding max-height 300ms ease-out;
      overflow: visible;
      max-height: 100%;
    }
  }
}
</style>
